import { api } from '../../services/api'
import moment from 'moment'
import { showError, showSuccess } from '../misc/misc.actions'
import { PROMO_STATUSES, standardizeEndOfDateUTC, standardizeStartOfDateUTC } from '../../utils'

const setStatus = (data) => {
	const { start_date, end_date, deactivated } = data
	const nowUTC = moment().utc()
	const startDate = standardizeStartOfDateUTC(start_date)
	const endDate = standardizeEndOfDateUTC(end_date)
	if (deactivated) {
		return PROMO_STATUSES.Deactivated
	}
	if (nowUTC.isBefore(startDate)) {
		return PROMO_STATUSES.Scheduled
	}
	if (nowUTC.isBetween(startDate, endDate, null, '[]')) {
		return PROMO_STATUSES.Running
	}
	if (nowUTC.isAfter(endDate)) {
		return PROMO_STATUSES.Completed
	}
}

export const fetchPromotions = async (dispatch, { facilityId } = {}) => {
	dispatch({ type: 'FETCH_PROMOTIONS' })
	try {
		const response = await api.get(`/promos`, {
			params: facilityId ? { facility_id: facilityId } : {}
		})
		const { data, errors } = response.data
		if (data) {
			// Enrich the data here with status
			for (const record of data) {
				// Create a derived field called status based on the start_date, end_date, and deactivated fields
				record.status = setStatus(record)

				record.applicable_markets = (record.applicable_markets || []).map((market) => market._id || market)
				record.applicable_facilities = (record.applicable_facilities || []).map(
					(facility) => facility._id || facility
				)
			}
			dispatch({ type: 'FETCH_PROMOTIONS_SUCCESS', payload: data })
		}
		if (errors && errors.length > 0) {
			dispatch(showError(errors[0]))
			dispatch({ type: 'FETCH_PROMOTIONS_FAIL' })
		}
	} catch (e) {
		dispatch({ type: 'FETCH_PROMOTIONS_FAIL' })
	}
}

export const updatePromotion = async (dispatch, updates, promo_id) => {
	if (!promo_id) {
		return
	}

	dispatch({ type: 'UPDATE_PROMOTION' })

	try {
		console.log('promo updates...', updates)

		const response = await api.patch(`/promos/${promo_id}`, updates)
		const { data, errors } = response.data

		console.log('data res...', data)

		if (data && data.length > 0) {
			// Enrich the data here with status
			for (const record of data) {
				// Create a derived field called status based on the start_date, end_date, and deactivated fields
				record.status = setStatus(record)
			}

			// console.log('data again...', promo_id, data)

			dispatch({ type: 'UPDATE_PROMOTION_SUCCESS', payload: { promo_id, updates: data[0] } })
			dispatch(showSuccess('Promotion updated successfully!'))
		}
		if (errors && errors.length > 0) {
			dispatch(showError(errors[0]))
			dispatch({ type: 'UPDATE_PROMOTION_FAIL' })
		}
	} catch (e) {
		dispatch({ type: 'FETCH_PROMOTIONS_FAIL' })
	}
}

export const savePromotion = async (dispatch, payload) => {
	dispatch({ type: 'SAVE_PROMOTION' })
	try {
		const response = await api.post(`/promos`, payload)
		const { data, errors } = response.data
		if (data && data.length > 0) {
			// Enrich the data here with status
			for (const record of data) {
				// Create a derived field called status based on the start_date, end_date, and deactivated fields
				record.status = setStatus(record)
			}
			dispatch({ type: 'SAVE_PROMOTION_SUCCESS', payload: data[0] })
			dispatch(showSuccess('Promotion saved successfully'))
		}
		if (errors && errors.length > 0) {
			dispatch(showError(errors[0]))
			dispatch({ type: 'SAVE_PROMOTION_FAIL' })
		}
	} catch (e) {
		dispatch({ type: 'FETCH_PROMOTIONS_FAIL' })
	}
}
